<template>
    <div class="product-param mb-2 px-3">
        <div class="row">
            <div class="col-md-12 mb-2 label-name">{{ label }}:</div>

            <div class="col-md-12 mb-2">
                <div class="product-param-container" :class="{ numerical: type != 'color' && type != 'diameter' }">
                    <div
                        v-for="item in list"
                        :key="item"
                        :class="{
                            active: item == selection.value,
                            available: isAvailable(item),
                            outOfStock: getStock(item) == 0,
                        }"
                        @click="onClick(item)"
                    >{{ item }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductParam',
    props: ['list', 'type', 'label', 'selection', 'available'],
    methods: {
        isAvailable(item){
            if(Array.isArray(this.available)){
              let available = this.available.map(value => (value.value?value.value.toString():''));
              return available.includes(item.toString());
            }
            return false;
        },
        getStock(item) {
            if (Array.isArray(this.available)) {
                const availableItem = this.available.find(avail => avail.value !== null && avail.value !== undefined && avail.value.toString() === item.toString());
                return availableItem && availableItem.stock !== undefined ? availableItem.stock : 0;
            }
            return 0;
        },
        onClick(item){
            if(this.isAvailable(item))
                this.$emit('selected', { value: item, type: this.type });
        }
    }
}
</script>